// TODO: should be marked as server-only
// import 'server-only';
import { cache as memoizedCache } from 'react';
import { DEFAULT_REVIEWS_LIMIT, DEFAULT_REVIEWS_OFFSET, Locale } from '@headless-workspace/config';
import { ResultServerActionType } from '@headless-workspace/core-domain';
import { RatingsAndReviewsValue } from '../../ratingsAndReviews';
import { getReviewsWithSorting } from '../getReviewsWithSorting';

export const getMemoReviewsWithSorting = memoizedCache(
    async (locale: Locale, productId: string): Promise<ResultServerActionType<RatingsAndReviewsValue>> => {
        return getReviewsWithSorting(locale, productId, DEFAULT_REVIEWS_OFFSET, DEFAULT_REVIEWS_LIMIT, []);
    },
);
